<template>
  <div>
    <title>券卡恢复使用</title>
    <article class="cardArticle">
      <section class="cardCon">
        <header class="tabHeader">
          <p>
            <router-link :to="{path:'/CardsOut'}" v-if="openStoreDefinition==1">券卡定义激活</router-link>
            <router-link :to="{path:'/CardsActivation'}">券卡激活</router-link>
            <router-link :to="{path:'/CardsPause'}">券卡暂停</router-link>
            <router-link :to="{path:'/CardsReuse'}">券卡恢复</router-link>
            <router-link :to="{path:'/CardsRecover'}" v-if="ElementControls('erjimendian')==1">销售回收</router-link>
            <router-link class="isActive" :to="{path:'/CardMdShop'}"   v-if="ElementControls('erjimendian')==1">门店铺券</router-link>
          </p>
        </header>
        <main class="cardMain">
          <!-- S 券卡验证表单 -->
          <CodeCheck v-if="update" @verifytype="verifyType" :operType="14" :codeType="codeType"></CodeCheck>
          <!-- E 券卡验证表单 -->
          <section>
            <el-form label-width="100px">
              <!-- S 基础设置 -->
              <p class="commonTit"><b>基础设置</b></p>
              <section class="basicSet">
                <el-form-item label="券卡流向" class="reFlowCon">
                  <el-button type="primary" size="small" v-if="mdlistdatil==''" plain @click="storeChoseDialogVisible = true">选择流向
                  </el-button>
                  <div v-if="mdlistdatil!=''" class="memberPop">
                    <ul class="flexBet">
                      <li class="flexUpDownCenter">
                        <div class="memberImg">
                          <img v-if="mdlistdatil.mainpiclink" :src="mdlistdatil.mainpiclink" alt="" />
                          <img v-else src="https://presale.jhtsoft.com/picms/c47499b67d489.png" alt="">
                        </div>
                        <div class="memberInfo">
                          <strong class="flexUpDownCenter"><span :title="mdlistdatil.flowname">{{mdlistdatil.flowname}}</span></strong>
                          <b class="commonNum">{{mdlistdatil.linkman}} </b>
                          <b class="commonNum">{{mdlistdatil.mobile}}</b>
                        </div>
                      </li>
                      <li>
                        <span @click="storeChoseDialogVisible = true">修改</span>
                      </li>
                    </ul>
                  </div>
                </el-form-item>
                <el-form-item label="备注">
                  <el-input type="textarea" v-model="basicForm.memo" maxlength="100"></el-input>
                </el-form-item>
              </section>
            </el-form>
          </section>
        </main>
        <div class="bottomBtn">
          <el-button type="primary" @click="suBmission" :loading="loadingshow">提交</el-button>
          <el-button @click="reload">重置</el-button>
        </div>
      </section>
    </article>

    <!-- S 选择二级门店 -->
    <StoreChose :chosestoreDatas="mdlistdatil" :objectType="9" :isSinglesel="1" :storeChoseDialogVisible="storeChoseDialogVisible" @closeChild="getCloseStoreCldd" @chosestoreData="chosestoreData"></StoreChose>
    <!-- E 选择二级门店 -->
  </div>
</template>
<script>
  import Api from "@/apis/api.js";
  import { Message, MessageBox } from "element-ui";
  import { mapState, mapActions } from "vuex";
  export default {
    name: 'CardsRecover',
    components: {
      CodeCheck: resolve =>
        require(["@/components/CardsFolder/CodeCheck.vue"], resolve), //验证全码
        StoreChose: resolve =>require(["@/components/CardsFolder/StoreChose.vue"], resolve), //选择二级门店
    },
    data() {
      return {
        mdlistdatil: '',
        openStoreDefinition: 0,
        loadingshow: false,
        update: true,
        codeType: '0',//券卡类型-礼品券卡
        labelPosition: "right", //labe文字右对齐,
        // 基础设置表单
        verifytype: 0,
        basicForm: {
          memo: '',//备注
        },
        storeChoseDialogVisible:false,
      }
    },
    // ==================================== 计算属性 ====================================
    computed: {
      ...mapState({
        bdis: ({ common }) => common.bdis,
      })
    },
    // ============================================== 方法 ==============================================
    methods: {
      // 关闭选择关联门店弹窗
    getCloseStoreCldd() {
      this.storeChoseDialogVisible = false;
    },
    //已绑定微门店数据
    chosestoreData(type){
      
      this.mdlistdatil = type;
      
    },
      // 验证类型
      verifyType(type) {
        this.verifytype = type
      },
      // 提交
      suBmission() {
        if(!this.mdlistdatil.flowcode){
          Message({
              type: 'warning',
              message:'请选择券卡流向！'
            });
           return
        }
        this.loadingshow = true;
        let param = {
          verifytype: this.verifytype,
          memo: this.basicForm.memo,
          flowcode: this.mdlistdatil.flowcode,
          flowname:this.mdlistdatil.flowname,
        }
        Api.MDPUQUANOPER(param).then(res => {
          if (res.data.status == "200") {
            this.reload();
            this.loadingshow = false;
            MessageBox.confirm(res.data.message, '提示', {
              confirmButtonText: '确定',
              showCancelButton: false,
              dangerouslyUseHTMLString: true,
              type: 'success'
            }).then(() => { }).catch(() => { });
          } else {
            if (res.data.status == "201") {
              this.reload();
            }
            this.loadingshow = false;
            MessageBox.confirm(res.data.message, '提示', {
              confirmButtonText: '确定',
              showCancelButton: false,
              dangerouslyUseHTMLString: true,
              type: 'warning'
            }).then(() => { }).catch(() => { });
          }
        }).catch((err)=>{
          this.loadingshow = false;
        })
      },
      reload() {
        this.basicForm = {
          memo: "", //备注
        }
        this.mdlistdatil=''
        // 移除组件
        this.update = false
        // 在组件移除后，重新渲染组件
        // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
        this.$nextTick(() => {
          this.update = true
        })
      }
    },
    mounted() {
      this.openStoreDefinition = this.ElementControls('openStoreDefinition')
    },
  }
</script>
<style scoped>
  .cardArticle {
    padding: 20px;
  }

  .cardMain>>>.el-input__inner {
    color: #666;
  }

  .cardCon {
    position: relative;
    padding: 84px 20px 85px 0;
    height: calc(100% - 169px);
  }

  @media (max-width: 1310px) {
    .cardCon header a {
      padding: 0 16px;
    }
  }

  .basicSet {
    padding: 20px;
  }

  .basicSet .el-input,
  .basicSet .el-textarea {
    width: 300px;
  }

  .memberPop {
    position: relative;
    background: #fff;
    border-radius: 4px;
    -o-box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
    -ms-box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
    -moz-box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
    -webkit-box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
  }

  .memberPop {
    margin-bottom: 5px;
    width: 270px;
    padding: 10px 20px 15px 10px;
    line-height: 1.5;
  }
  .memberPop .memberImg {
    width: 60px;
    height: 60px;
    position: relative;
  }

  .memberPop .memberImg img {
    max-width: 100%;
    max-height: 100%;
    /* border-radius: 100%; */
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }

  .memberPop .memberInfo {
    margin-left: 10px;
  }

  .memberPop .memberInfo strong {
    color: #666;
    font-weight: bold;
  }

  .memberPop .memberInfo strong span {
    max-width: 160px;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .memberPop .memberInfo strong i {
    color: var(--main-color);
    font-size: 18px;
    margin-left: 5px;
    vertical-align: text-bottom;
  }

  .memberPop .memberInfo b {
    color: #999;
    display: block;
    line-height: 20px;
  }

  .memberPop .memberInfo em {
    width: 60px;
    height: 20px;
    border-radius: 10px;
    background: #f2962c;
    color: #fff;
    font-size: 12px;
    padding: 2px 6px;
  }

  .memberPop li:last-child {
    color: var(--main-color);
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// src/views/CardsFolder/CardsGift/CardManage/CardMdShop.vue